import { Component } from '@angular/core';

import { RouterModule } from '@angular/router';
@Component({
    selector: 'app-acesso-negado',
  imports: [RouterModule],
    templateUrl: './acesso-negado.component.html',
    styleUrls: ['./acesso-negado.component.sass'],
    standalone: true
})
export class AcessoNegadoComponent {

  constructor() { }


}
